// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DaySelector_container__zTkC- {
  min-width: 264px;
}

.DaySelector_month-selector__\\+NARo {
  display: flex;
  gap: 0.5rem;
}
.DaySelector_month-selector__\\+NARo span {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
}

.DaySelector_calendar__sfnJ0 {
  display: grid;
  grid-template-columns: repeat(7, 1fr);
  gap: 2px;
}

.DaySelector_weekday__V30UQ {
  text-align: center;
}

.DaySelector_day__xy4-W {
  aspect-ratio: 1/1;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #d1d1d1;
  cursor: default;
}
.DaySelector_day__xy4-W.DaySelector_selectable__kA50Q {
  cursor: pointer;
  color: #454545;
}
.DaySelector_day__xy4-W.DaySelector_selectable__kA50Q:hover {
  outline: 1px solid black;
}
.DaySelector_day__xy4-W.DaySelector_selected__ixpOT {
  background-color: #454545;
  color: white;
}`, "",{"version":3,"sources":["webpack://./src/components/DatePicker/DaySelector.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,WAAA;AACF;AAAE;EACE,SAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAEJ;;AAEA;EACE,aAAA;EACA,qCAAA;EACA,QAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,iBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,eAAA;AACF;AACE;EACE,eAAA;EACA,cAAA;AACJ;AAAI;EACE,wBAAA;AAEN;AAEE;EACE,yBAAA;EACA,YAAA;AAAJ","sourcesContent":[".container {\n  min-width: 264px;\n}\n\n.month-selector {\n  display: flex;\n  gap: 0.5rem;\n}\n.month-selector span {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.calendar {\n  display: grid;\n  grid-template-columns: repeat(7, 1fr);\n  gap: 2px;\n}\n\n.weekday {\n  text-align: center;\n}\n\n.day {\n  aspect-ratio: 1/1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #d1d1d1;\n  cursor: default;\n}\n.day.selectable {\n  cursor: pointer;\n  color: #454545;\n}\n.day.selectable:hover {\n  outline: 1px solid black;\n}\n.day.selected {\n  background-color: #454545;\n  color: white;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `DaySelector_container__zTkC-`,
	"month-selector": `DaySelector_month-selector__+NARo`,
	"calendar": `DaySelector_calendar__sfnJ0`,
	"weekday": `DaySelector_weekday__V30UQ`,
	"day": `DaySelector_day__xy4-W`,
	"selectable": `DaySelector_selectable__kA50Q`,
	"selected": `DaySelector_selected__ixpOT`
};
export default ___CSS_LOADER_EXPORT___;
